import JS from "./images/js.png";
import HTML from "./images/html.png";
import CSS from "./images/css.png";
import ReactIcon from "./images/react.png";
import Graph from "./images/graphql.png";
import Bootstrap from "./images/bootstrap.png";
import Github from "./images/github.png";
import Sass from "./images/sass.png";
import Redux from "./images/redux.png";
import Rest from "./images/rest.png";
import Swift from "./images/swift.png";
import Typescript from "./images/typescript.png";
import StyledComponents from "./images/styledComponents.png";
import Nodejs from "./images/nodejs.svg";
import Mongo from "./images/mongo.png";

const Techs = [
  { name: "Html 5", icon: HTML },
  { name: "CSS 3", icon: CSS },
  { name: "JavaScript", icon: JS },
  { name: "React & Native", icon: ReactIcon },
  { name: "Redux", icon: Redux },
  { name: "GraphQL API", icon: Graph },
  { name: "RESTful API", icon: Rest },
  { name: "Bootstrap", icon: Bootstrap },
  { name: "GitHub", icon: Github },
  { name: "Sass", icon: Sass },
  { name: "Swift", icon: Swift },
  { name: "TypeScript", icon: Typescript },
  { name: "Styled Components", icon: StyledComponents },
  { name: "MongoDb", icon: Mongo },
  { name: "Node JS", icon: Nodejs },
];

export default Techs;
